/**
 * The lead time a reopened survey's dates need, shared by the per-row and bulk reopen forms.
 *
 * One hour, matching the backend rule exactly (`end >= now + 1h`, and `start >= now + 1h` when
 * scheduling). Both forms used to demand the *next day* instead. Nothing invalid ever reached the
 * endpoint that way, but it refused dates the backend accepts — including the case the reopen rules
 * were rewritten to allow: undoing an early close by reopening a section to its own existing end
 * date, which is often later the same day.
 *
 * Defined once because the floor has to match the backend in both surfaces, and a rule copied into
 * five schema fields is one that drifts.
 */

/** Milliseconds of lead time the backend requires before a reopened survey's dates. */
export const REOPEN_MIN_LEAD_MS = 60 * 60 * 1000

/**
 * A `.test` predicate rather than yup's `.min`, deliberately.
 *
 * `.min` takes a value, not a getter, so the floor is fixed when the schema is built — in
 * `ReopenSurveyModal` that meant module import. A tab left open overnight validated against a
 * boundary that had since passed. Computing it per validation keeps the rule true for as long as
 * the form is on screen.
 */
export const isAtLeastAnHourAway = (value?: Date | null): boolean =>
  !value || value.getTime() >= Date.now() + REOPEN_MIN_LEAD_MS

/** "<Field> must be at least one hour from now" — one phrasing, so the three fields agree. */
export const anHourAwayMessage = (field: string): string =>
  `${field} must be at least one hour from now`
